import type { GetUnchargedUsageReportResponsePayload } from '@vy/api-definition';
import { GetUnchargedUsageReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined, withDefault } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useUnchargedUsageReport(
  reportId?: string,
  options?: CustomUseQueryOptions<GetUnchargedUsageReportResponsePayload>,
) {
  const reportIdentifier = withDefault(reportId, '');
  const getUnchargedUsageReportQuery = useQuery(
    queryKeys.unchargedUsageReport(reportIdentifier),
    async () => {
      const api = getPrivateApi();
      const getUnchargedUsageReportResponse = await api.getUnchargedUsageReport({ reportId });

      return GetUnchargedUsageReportResponseSchema.parse(getUnchargedUsageReportResponse);
    },
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(getUnchargedUsageReportQuery.data, 'getUnchargedUsageReportQuery data');

  return getUnchargedUsageReportQuery;
}
